import isExperienceEditor from "@utils/is-experience-editor";

var VCA = VCA || {};


VCA.PCCSlider = (function ($) {

    var ui = {};
    var MEDIA_QUERY = '(max-width: 767px)';
    var mql = window.matchMedia(MEDIA_QUERY);
    var started = false;

    function init() {
        if ($('[data-slider="PCC-slider"]').length <= 0) {
            return;
        }

        cacheUI();
        initPCCSlider();
        initPCCThumbsSlider();
        bindnavClick();
    }

    function cacheUI() {
        ui.$body = $('body');
        ui.$PCCSlider = $('[data-slider="PCC-slider"]');
        ui.$PCCThumbsSlider = $('[data-slider="PCC-thumbs-slider"]');
    }

    function initPCCSlider(e) {
        ui.$PCCSlider.each(function (index, element) {

            $(this).addClass('js-pcc-slider' + index).data('index',index);
            var navSlider = '.js-pcc-slider-thumbs' + index +',' +  '.js-pcc-slider-caption' + index;
            var statusBox = '.js-pcc-slider-arrows-wrap' + index;
            var item_length = $('.js-pcc-slider' + index + ' > div').length;
            if (item_length > 1 && !isExperienceEditor) {
                $('.js-pcc-slider' + index).slick({
                    autoplay: false,
                    infinite: false,
                    arrows: true,
                    dots: false,
                    rows: 0,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    asNavFor: navSlider,
                    appendArrows: statusBox,
                    focusOnSelect: true,
                    accessibility: false
                });
            }else {
                $(statusBox).hide();
            }


        });


    };

    function initPCCThumbsSlider(e) {
        ui.$PCCThumbsSlider.each(function (index, element) {
            $(this).addClass('js-pcc-slider-thumbs' + index).data('index-thumb',index);
            var navSlider = '.js-pcc-slider' + index +',' +  '.js-pcc-slider-caption' + index;
            console.log(navSlider);
            var item_length = $('.js-pcc-slider-thumbs' + index + ' > div').length;
            if (item_length > 1 && !isExperienceEditor) {
                $('.js-pcc-slider-thumbs' + index).slick({
                    autoplay: false,
                    infinite: false,
                    arrows: true,
                    dots: false,
                    rows: 0,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    focusOnSelect: false,
                    accessibility: true
                });
            }else {
                $('.js-pcc-slider-thumbs' + index).hide();
            }
        });
    };

    function bindnavClick() {
        $(document).on('click', '.m-article-hero-thumbs .swiper-slide', function(event) {
            let parentSLider = $(this).closest('.swiper-wrapper');
            parentSLider.find('.swiper-slide-active').removeClass('swiper-slide-active');
            $(this).addClass('swiper-slide-active');
            let slideIndex = $(this).data('slick-index');
            let sliderIndex = parentSLider.data('index-thumb');
            $('.js-pcc-slider' + sliderIndex).slick("slickGoTo", slideIndex);
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.PCCSlider.init();
});